import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export function SiReferAndEarn(props: IconProps): React.ReactElement {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13.5 5c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11 0c0-1.105-2.462-2-5.5-2s-5.5.895-5.5 2m11 0v4.457c-1.222.367-2 .922-2 1.543m-9-6v12c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457V11m-9-2c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457M2.5 13c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457M22.5 11c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11 0c0-1.105-2.462-2-5.5-2s-5.5.895-5.5 2m11 0v8c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2v-8m11 4c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2"
      />
    </Icon>
  );
}
